export default class Coordinate {
  constructor(...args) {
    if (args.length === 1) {
      // If an array is passed in, treat it as a lat, lng pair
      [this.lat, this.lng] = args[0];
    } else if (args.length === 2) {
      // Otherwise, assume lat, lng was passed in as separate arguments
      [this.lat, this.lng] = args;
    }
  }

  toGeoJSON() {
    return {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Point',
        coordinates: [this.lng, this.lat],
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/common/types/Coordinate.js